import { jsxs as N, jsx as e } from "react/jsx-runtime";
import v from "classnames";
import { useMemo as x, cloneElement as F } from "react";
import { useIsMessageTwoLine as C } from "./index.es571.js";
import * as o from "@radix-ui/react-popover";
import i from "./index.es759.js";
import E from "./index.es760.js";
import { Provider as S, Viewport as b } from "@radix-ui/react-toast";
import { uniqueId as A } from "lodash/fp";
import { BodyText as L } from "./index.es487.js";
import { UtilityCloseIcon as P } from "./index.es439.js";
import { PrimitiveToast as D } from "./index.es752.js";
const R = "flash-message", z = ({
  LeftIcon: r,
  children: m,
  onClose: a,
  testId: t = R,
  open: c,
  customPositioning: M,
  duration: T,
  isInStack: w,
  onOpenChange: d,
  variant: f,
  anchor: n,
  ...y
}) => {
  const { containerRef: h, is2Liner: l } = C(), s = f === "inverted", p = v(i.leftIcon, {
    [i.inverted]: s,
    [i.is2Liner]: l
  }), u = v(i.root, {
    [i.alignTop]: l,
    [i.is2Liner]: l
  }), g = x(
    () => /* @__PURE__ */ N("div", { className: u, children: [
      r && /* @__PURE__ */ e("span", { className: p, "data-testid": `${t}-left-icon`, children: F(r, {
        outline: s ? "white" : "default-gray"
      }) }),
      /* @__PURE__ */ e("div", { className: i.textContainer, ref: h, children: /* @__PURE__ */ e(
        L,
        {
          variant: "semi-bold",
          element: "p",
          color: s ? "white" : "primary",
          children: m
        }
      ) }),
      a && /* @__PURE__ */ e(
        "span",
        {
          className: i.closeButton,
          "data-testid": `${t}-close-button`,
          onClick: a,
          children: /* @__PURE__ */ e(P, { outline: s ? "white" : "default-gray" })
        }
      )
    ] }),
    [
      r,
      m,
      h,
      s,
      p,
      a,
      u,
      t
    ]
  );
  return n ? /* @__PURE__ */ N(o.Root, { open: c, onOpenChange: d, children: [
    /* @__PURE__ */ e(o.Anchor, { children: n.anchorTo }),
    /* @__PURE__ */ e(o.Portal, { children: /* @__PURE__ */ e(
      o.Content,
      {
        className: E.notificationContainer,
        sideOffset: 8,
        side: "bottom",
        align: "start",
        ...n,
        children: g
      }
    ) })
  ] }) : /* @__PURE__ */ e(S, { swipeDirection: "right", children: /* @__PURE__ */ e(b, { className: i.flashMessageViewport, label: A("Flash Messages - "), children: /* @__PURE__ */ e(
    D,
    {
      open: c,
      customPositioning: M,
      duration: T,
      isInStack: w,
      onOpenChange: d,
      variant: f,
      testId: t,
      isFlashMessage: !0,
      ...y,
      children: g
    }
  ) }) });
};
export {
  R as DEFAULT_FLASH_MESSAGE_TESTID,
  z as FlashMessage
};
//# sourceMappingURL=index.es87.js.map
